



























import Vue, {PropType} from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { ComponentOptions } from 'vue/types/umd'

@Component
export default class Flex extends Vue {
    @Prop({default: false})
    selected!: boolean

    @Prop({default: false})
    timestamps!: boolean

    @Prop({default: true})
    command!: boolean

    @Prop({default: true})
    gutter!: boolean

    @Prop({default: true})
    nodeBadge!: boolean

    @Prop({default: true})
    lineWrap!: boolean

    get displayNodeBadge() {
        return this.$options.entry.nodeBadge && this.nodeBadge
    }

    get displayGutter() {
        return this.gutter && (this.timestamps || this.command)
    }

    $options!: ComponentOptions<Vue> & {
        entry: any
    }

    lineSelect() {
        this.$emit('line-select', this.$options.entry.lineNumber)
    }
}
